const FACE_RESULT_STORAGE_KEY = 'startus:face:last-result';
const FACE_RESULT_STORAGE_VERSION = 1;
const FACE_RESULT_TTL_MS = 30 * 60 * 1000;

function getStorage() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
}

function readJson(key) {
  try {
    const raw = getStorage()?.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeJson(key, value) {
  try {
    getStorage()?.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore storage failures.
  }
}

function removeValue(key) {
  try {
    getStorage()?.removeItem(key);
  } catch {
    // Ignore cleanup failures.
  }
}

function isValidPayload(payload) {
  return Boolean(
    payload &&
    payload.result &&
    (payload.result.id || payload.result.result_id || payload.result.persona || payload.result.masculinity_label)
  );
}

export function writeStoredFaceResult(payload) {
  if (!isValidPayload(payload)) {
    return false;
  }

  const savedAt = Date.now();
  writeJson(FACE_RESULT_STORAGE_KEY, {
    version: FACE_RESULT_STORAGE_VERSION,
    savedAt,
    expiresAt: savedAt + FACE_RESULT_TTL_MS,
    payload,
  });
  return true;
}

export function readStoredFaceResult() {
  const record = readJson(FACE_RESULT_STORAGE_KEY);
  if (!record) {
    return { status: 'missing', data: null };
  }

  if (record.version !== FACE_RESULT_STORAGE_VERSION) {
    removeValue(FACE_RESULT_STORAGE_KEY);
    return { status: 'version_mismatch', data: null };
  }

  if (!record.expiresAt || Date.now() > record.expiresAt) {
    removeValue(FACE_RESULT_STORAGE_KEY);
    return { status: 'expired', data: null };
  }

  if (!isValidPayload(record.payload)) {
    removeValue(FACE_RESULT_STORAGE_KEY);
    return { status: 'corrupt', data: null };
  }

  return {
    status: 'available',
    data: record.payload,
  };
}

export function clearStoredFaceResult() {
  removeValue(FACE_RESULT_STORAGE_KEY);
}
